import type { FileProps } from '@george-labs.com/design-system/types/components/Input/FileInput/components';

import type { BankMessageAttachment } from '../BankMessagesTypes';

export const MESSAGE_ALLOWED_TAGS = [
    'br',
    'p',
    'b',
    'strong',
    'i',
    'em',
    'u',
    'ul',
    'ol',
    'li',
    'a',
    'img',
];

export const getFileListItems = (attachments: BankMessageAttachment[]): FileProps[] =>
    attachments.map(({ id, fileName, fileSize }) => ({
        id,
        name: fileName,
        size: fileSize,
    }));
